/**
 * REF-08: windowed pagination. The page list a pager renders so the
 * control row fits one line at any page count: the first two and last
 * two pages plus a window around the current page, with 'ellipsis'
 * markers for the gaps. At 7 or fewer pages every page is listed.
 * Pure and shared by the Candidates pager and both commission pagers
 * so the three constructions cannot drift apart.
 */
export type PageWindowItem = number | 'ellipsis';

export function pageWindow(current: number, total: number): PageWindowItem[] {
  if (total <= 7) {
    return Array.from({ length: Math.max(total, 0) }, (_, i) => i + 1);
  }
  const wanted = new Set<number>([1, 2, total - 1, total, current - 1, current, current + 1]);
  const pages = [...wanted].filter(p => p >= 1 && p <= total).sort((a, b) => a - b);
  const out: PageWindowItem[] = [];
  let prev = 0;
  for (const p of pages) {
    if (prev && p - prev > 1) out.push('ellipsis');
    out.push(p);
    prev = p;
  }
  return out;
}
